import { Box } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { LoginBody } from '../components/organisms/Login/LoginBody';
import { LoginHeader } from '../components/organisms/Login/LoginHeader';

interface props {
  setIsLogin: React.Dispatch<React.SetStateAction<boolean>>;
}
export const Login: React.FC<props> = (props) => {
  const { setIsLogin } = props;

  useEffect(() => {
    sessionStorage.clear();
  }, []);
  return (
    <Box h='100vh'>
      <LoginHeader />
      <LoginBody setIsLogin={setIsLogin} />
    </Box>
  );
};
